(() => {
  const mergeData = (base, override) => {
    if (!override || typeof override !== "object") return base;
    if (Array.isArray(override)) return override.slice();
    const output = { ...(base && typeof base === "object" && !Array.isArray(base) ? base : {}) };
    Object.entries(override).forEach(([key, value]) => {
      output[key] = value && typeof value === "object" && !Array.isArray(value)
        ? mergeData(output[key], value)
        : Array.isArray(value) ? value.slice() : value;
    });
    return output;
  };
  const shopifyAsset = value => {
    if (!window.GF_ASSET_BASE || typeof value !== "string" || !value.startsWith("/assets/")) return value;
    const filename = value.split("/").pop().replace(/\.(png|jpe?g)$/i, ".webp");
    return window.GF_ASSETS?.[filename] || window.GF_ASSET_BASE + filename;
  };
  const normalizeAssets = value => {
    if (Array.isArray(value)) return value.map(normalizeAssets);
    if (value && typeof value === "object") return Object.fromEntries(Object.entries(value).map(([key, item]) => [key, normalizeAssets(item)]));
    return shopifyAsset(value);
  };
  const DATA = normalizeAssets(mergeData(window.STORE_DATA || {}, window.GF_THEME_DATA || {}));
  const SHOPIFY = window.GF_SHOPIFY?.enabled ? window.GF_SHOPIFY : null;
  window.GF_ASSET = name => shopifyAsset(`/assets/${name}`);
  const product = DATA.product;
  const COPY = DATA.copy || {};
  const MEDIA = DATA.media || {};
  const text = (key, fallback) => COPY[key] || fallback;
  const media = (key, fallback) => MEDIA[key] || fallback;
  const mediaAsset = (key, name) => media(key, window.GF_ASSET ? window.GF_ASSET(name) : "/assets/" + name);
  const ivkHref = href => href === "/products/gercekform" ? "/products/ivk" : href;
  const footerLinks = [
    { label: "Ürünlerimiz", href: "/products/ivk" },
    { label: "İletişim", href: "mailto:info@ivksatis.com" },
    { label: "Gizlilik Politikası", href: "#ivk-gizlilik", policy: "ivk-gizlilik" },
    { label: "İade ve Değişim Politikası", href: "#ivk-iade-degisim", policy: "ivk-iade-degisim" },
    { label: "Kargo Politikası", href: "#ivk-kargo", policy: "ivk-kargo" },
    { label: "Hizmet Koşulları", href: "#ivk-hizmet-kosullari", policy: "ivk-hizmet-kosullari" }
  ];
  const infoPages = {
    "/pages/ivk-gizlilik": {
      title: "IVK Gizlilik Politikası",
      paragraphs: [
        "IVK, siparişlerinizi işlemek, müşteri desteği sağlamak ve alışveriş deneyiminizi geliştirmek için gerekli kişisel bilgileri işler. Ödeme ve mağaza altyapımız Shopify tarafından sağlanmaktadır.",
        "Bilgileriniz yasal zorunluluklar dışında izniniz olmadan üçüncü taraflara satılmaz. Gizlilik talepleriniz için info@ivksatis.com adresinden bize ulaşabilirsiniz."
      ]
    },
    "/pages/ivk-iade-degisim": {
      title: "IVK İade ve Değişim Politikası",
      paragraphs: [
        "Ürün bedeninize uymazsa 30 gün içinde değişim talep edebilirsiniz.",
        "Değişim talebiniz için sipariş bilgilerinizle birlikte info@ivksatis.com adresinden bize ulaşabilirsiniz."
      ]
    },
    "/pages/ivk-kargo": {
      title: "IVK Kargo Politikası",
      paragraphs: [
        "Siparişler Türkiye'nin her yerine ücretsiz kargo ile gönderilir. Siparişiniz kargoya verildiğinde takip bilgileri sizinle paylaşılır.",
        "Kargo desteği için info@ivksatis.com adresinden bize ulaşabilirsiniz."
      ]
    },
    "/pages/ivk-hizmet-kosullari": {
      title: "IVK Hizmet Koşulları",
      paragraphs: [
        "ivksatis.com üzerinden verilen siparişlerde ekranda gösterilen ürün, paket, renk, beden ve fiyat bilgileri esas alınır.",
        "Siteyi kullanarak sipariş ve ödeme adımlarında verdiğiniz bilgilerin doğru olduğunu kabul edersiniz. Sorularınız için info@ivksatis.com adresinden bize ulaşabilirsiniz."
      ]
    }
  };
  const lazyVideo = (src, poster, attributes = "") => `<video data-src="${src}" poster="${poster}" preload="none" muted loop playsinline ${attributes}></video>`;

  const initialCart = JSON.parse(localStorage.getItem("ivk-cart") || localStorage.getItem("gercekform-cart") || "[]");

  const state = {
    selectedImage: 0,
    selectedColor: product.colors[0].name,
    selectedSize: product.sizes[2] || product.sizes[0], // Default L
    homeColor: product.colors[0].name,
    homeSize: product.sizes[0],
    selectedBundle: product.bundles[1] ? product.bundles[1].id : product.bundles[0].id, // Default İkili Alım
    bundleItems: {
      single: [{ color: product.colors[0].name, size: product.sizes[2] || "L" }],
      double: [
        { color: product.colors[0].name, size: product.sizes[2] || "L" },
        { color: product.colors[0].name, size: product.sizes[2] || "L" }
      ],
      triple: [
        { color: product.colors[0].name, size: product.sizes[2] || "L" },
        { color: product.colors[0].name, size: product.sizes[2] || "L" },
        { color: product.colors[0].name, size: product.sizes[2] || "L" }
      ]
    },
    openDropdown: null,
    cart: initialCart,
    menuOpen: false,
    cartOpen: false,
    reviewPage: 1,
    discountCode: "",
    testimonialIndex: 0,
    reserveTimerSeconds: 600
  };

  const icons = {
    search: `<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"></circle><path d="m20 20-4-4"></path></svg>`,
    user: `<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="7" r="4"></circle><path d="M4 21c.7-5 3.4-7 8-7s7.3 2 8 7"></path></svg>`,
    bag: `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 8h14l-1 13H6L5 8Z"></path><path d="M9 9V6a3 3 0 0 1 6 0v3"></path></svg>`,
    menu: `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h18M3 12h18M3 18h18"></path></svg>`,
    close: `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m5 5 14 14M19 5 5 19"></path></svg>`,
    arrow: `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 5 7 7-7 7"></path></svg>`,
    plus: `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M12 5v14"></path></svg>`,
    minus: `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14"></path></svg>`,
    truck: `<svg class="perk-icon truck" viewBox="0 0 24 24" aria-hidden="true"><path d="M2 6h13v10H2zM15 10h4l3 3v3h-7z"></path><circle cx="6" cy="18" r="2"></circle><circle cx="18" cy="18" r="2"></circle></svg>`,
    heart: `<svg class="perk-icon heart" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21S3 15.4 3 8.8C3 5.3 7.4 3.4 12 7c4.6-3.6 9-1.7 9 1.8C21 15.4 12 21 12 21z"></path></svg>`
  };

  const money = value => {
    const amount = Number(value);
    const hasFraction = Math.abs(amount - Math.round(amount)) > 0.00001;
    return `${amount.toLocaleString("en-US", {
      minimumFractionDigits: hasFraction ? 2 : 0,
      maximumFractionDigits: 2
    })}TL`;
  };
  const moneyFixed = value => `${Number(value).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })}TL`;
  const escapeHTML = value => String(value ?? "").replace(/[&<>'"]/g, char => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", "'": "&#39;", '"': "&quot;" })[char]);
  const stars = rating => `<span class="stars" aria-label="${rating} yıldız">${"★".repeat(Math.floor(rating))}${rating < 5 ? "☆" : ""}</span>`;
  const currentPath = () => window.location.pathname.replace(/\/$/, "") || "/";

  function header() {
    const path = currentPath();
    return `
      <header class="site-header">
        <div class="countdown-bar">
          <span class="countdown-label">${DATA.announcements.countdownLabel}</span>
          <div class="countdown" aria-label="İndirim sayacı">
            <span class="time-box"><b data-time="hours">00</b><small>SAAT</small></span><i>:</i>
            <span class="time-box"><b data-time="minutes">15</b><small>DK</small></span><i>:</i>
            <span class="time-box"><b data-time="seconds">00</b><small>SN</small></span>
          </div>
        </div>
        <div class="offer-bar">${DATA.announcements.offer}</div>
        <div class="nav-shell">
          <button class="icon-button mobile-only" data-action="menu" aria-label="Menüyü aç">${icons.menu}</button>
          <button class="icon-button search-button" data-action="search" aria-label="Ara">${icons.search}</button>
          <a class="brand" href="/" aria-label="Ana sayfa"><span class="brand-text">IVK</span></a>
          <nav class="desktop-nav" aria-label="Ana menü">
            ${DATA.navigation.map(item => `<a class="${item.href === "/" && path === "/" ? "active" : ""}" href="${ivkHref(item.href)}">${item.label}</a>`).join("")}
          </nav>
          <div class="nav-actions">
            <a class="icon-button desktop-only" href="/account" aria-label="Hesabım">${icons.user}</a>
            <button class="icon-button bag-button" data-action="cart" aria-label="Sepeti aç">${icons.bag}<span class="cart-count">${cartCount()}</span></button>
          </div>
        </div>
        <div class="perk-bar"><span>${icons.truck}${DATA.announcements.left}</span><span>${icons.heart}${DATA.announcements.right}</span></div>
      </header>
    `;
  }

  function mobileMenu() {
    return `
      <div class="menu-overlay" data-action="close-menu"></div>
      <aside class="mobile-menu" aria-hidden="true">
        <div class="mobile-menu-head"><span>${text("mobileMenuTitle", "Menu")}</span><button class="icon-button" data-action="close-menu">${icons.close}</button></div>
        <nav>${DATA.navigation.map(item => `<a href="${ivkHref(item.href)}">${item.label}<span>${icons.arrow}</span></a>`).join("")}</nav>
        <div class="mobile-menu-foot"><a href="/account/login">${text("mobileLogin", "Oturum aç")}</a><small>${text("mobileSupport", "Her gün 09:00–18:00 destek")}</small></div>
      </aside>
    `;
  }

  function homePage() {
    return `
      <main id="main" class="home-page">
        <section class="home-hero reveal">
          <div class="hero-copy">
            <p class="hero-eyebrow">${DATA.hero.eyebrow}</p>
            <h2>${DATA.hero.title}</h2>
            <p>${DATA.hero.body}</p>
            <a class="button hero-button" href="/products/ivk">${DATA.hero.cta}</a>
          </div>
          <div class="hero-image" role="img" aria-label="IVK sütyen" style="background-image:url('${DATA.hero.image}')"></div>
        </section>
        ${marquee("feature-marquee")}
        <section class="testimonials reveal">
          <h2>${text("homeTestimonialsTitle", "Kadınların IVK Hakkındaki Görüşleri")}</h2>
          <div class="testimonial-track">
            ${DATA.testimonials.map((item, index) => `<article class="testimonial-card" data-testimonial="${index}"><p>${item.quote}</p><strong>${item.name}</strong></article>`).join("")}
          </div>
          <div class="slider-controls mobile-only"><button data-action="testimonial-prev" aria-label="Önceki">‹</button><span class="dots">${DATA.testimonials.map((_, i) => `<i class="${i === 0 ? "active" : ""}"></i>`).join("")}</span><button data-action="testimonial-next" aria-label="Sonraki">›</button></div>
        </section>
        <section class="home-product reveal">
          ${productGallery("home")}
          ${productInfo("home")}
        </section>
        <h2 class="choice-title reveal">${text("homeChoiceTitle", "Binlerce Kadının Tercihi")}</h2>
        ${reviewsSection("home")}
      </main>
    `;
  }

  function marquee(extra = "") {
    const items = [...DATA.marquee, ...DATA.marquee];
    return `<div class="marquee ${extra}" aria-label="Ürün özellikleri"><div>${items.map(item => `<span>${item}</span>`).join("")}</div></div>`;
  }

  function productGallery(context = "product") {
    return `
      <div class="product-gallery ${context === "home" ? "home-gallery" : ""}">
        <div class="gallery-stage">
          <button class="gallery-arrow prev" data-action="gallery-prev" aria-label="Önceki görsel">‹</button>
          <img class="gallery-main" src="${product.images[state.selectedImage]}" alt="${product.name}" />
          <button class="gallery-arrow next" data-action="gallery-next" aria-label="Sonraki görsel">›</button>
          ${context === "home" ? `<span class="home-gallery-zoom" aria-hidden="true">${icons.search}</span>` : ""}
        </div>
        ${context === "product" ? `<div class="thumbnail-list">${product.images.map((src, index) => `<button class="thumbnail ${index === state.selectedImage ? "active" : ""}" data-action="gallery-select" data-index="${index}" aria-label="Görsel ${index + 1}"><img src="${src}" alt="${product.name} ${index + 1}" loading="${index > 5 ? "lazy" : "eager"}" /></button>`).join("")}</div>` : ""}
      </div>
    `;
  }

  function productInfo(context = "product") {
    const isHome = context === "home";
    return `
      <div class="product-info ${isHome ? "home-product-info" : ""}" data-product-info>
        <div class="rating-line">${stars(5)} <span>${isHome ? product.shortLabel : `${text("ratingPrefix", "Mükemmel")} ${product.rating} | ${product.ratingCount} ${text("ratingSuffix", "değerlendirme")}`}</span></div>
        <h1>${product.name}</h1>
        ${!isHome ? `<p class="product-subtitle">${product.subtitle}</p>` : ""}
        <div class="price-line"><strong>${moneyFixed(product.price)}</strong><del>${moneyFixed(product.compareAt)}</del><span class="discount-badge">🏷 ${product.discount}% İNDİRİM</span></div>
        ${!isHome ? `<ul class="feature-list">${product.features.map(item => `<li>${item}</li>`).join("")}</ul><p class="stock-line">${text("stockText", "◉ STOKLAR TAMAMEN GÜNCELLENDİ!")}</p><div class="bundle-heading"><span>${text("bundleHeading", "DAHA FAZLA AL – DAHA FAZLA CEBİNDE KALSIN")}</span></div><div class="flash-offer"><span>⏰ Gece 00:00’da Bitiyor! İndirim</span> <b data-flash-time>08:55:56</b></div>${bundleOptions()}` : ""}
        ${isHome ? variantOptions(true) : ""}
        <button class="button add-button" type="button" data-action="add-cart">${text("addToCart", "SEPETE EKLE")}</button>
        ${isHome ? `<button class="button cod-button home-cod-button" type="button" data-action="buy-now"><strong>${text("codBuyNow", "Kapıda Ödeme ile Satın Al")}</strong><small>${text("codFreeShipping", "+ Ücretsiz Kargo")}</small></button><a class="details-link" href="/products/ivk">${text("detailsLink", "Tüm ayrıntıları görüntüle")} <span>→</span></a>` : `
          <button class="button cod-button" type="button" data-action="buy-now">
            <strong>${text("codBuyNow", "Kapıda Ödeme ile Satın Al")}</strong>
            <small>${text("codFreeShipping", "+ Ücretsiz Kargo")}</small>
          </button>
          <div class="payment-icons cod-payment-icons" aria-label="Kabul edilen ödeme yöntemleri">
            <span class="pay-apple">Pay</span><span class="pay-mastercard"><i></i><i></i></span><span class="pay-visa">VISA</span><span class="pay-google"><b>G</b> Pay</span>
          </div>
          <div class="cod-benefits">
            <span><i aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M3 6h11v10H3zM14 10h4l3 3v3h-7zM6 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm12 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/></svg></i><b>${text("codBenefitShipping", "Türkiye'nin Her Yerine Ücretsiz Kargo")}</b></span>
            <span><i aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M12 2 20 5v6c0 5.1-3.4 9-8 11-4.6-2-8-5.9-8-11V5l8-3Z"/><path d="m8.5 12 2.2 2.2 4.8-5"/></svg></i><b>${text("codBenefitReturns", "30 Gün Boyunca Kolay İade ve Değişim")}</b></span>
          </div>
          ${accordionList(DATA.accordions, "details")}`}
      </div>
    `;
  }

  function customColorSelect(bundleId, itemIndex, currentColor) {
    const isOpen = state.openDropdown
      && state.openDropdown.bundleId === bundleId
      && state.openDropdown.itemIndex === itemIndex
      && state.openDropdown.type === 'color';
      
    const selectedObj = product.colors.find(c => c.name === currentColor) || product.colors[0];

    return `
      <div class="custom-dropdown-wrap ${isOpen ? 'open' : ''}">
        <button class="custom-dropdown-trigger color-trigger" data-action="toggle-dropdown" data-bundle="${bundleId}" data-index="${itemIndex}" data-type="color" type="button">
          <i class="color-circle ${selectedObj.inStock === false ? 'slashed' : ''}" style="background:${selectedObj.value}"></i>
          <span class="trigger-label">${selectedObj.name}</span>
          <i class="trigger-arrow">▾</i>
        </button>
        ${isOpen ? `
          <div class="custom-dropdown-menu color-menu">
            ${product.colors.map(color => {
              const isSelected = color.name === currentColor;
              const isOut = color.inStock === false;
              return `
                <div class="custom-dropdown-item ${isSelected ? 'selected' : ''} ${isOut ? 'out-of-stock' : ''}" 
                     data-action="select-dropdown-option" 
                     data-bundle="${bundleId}" 
                     data-index="${itemIndex}" 
                     data-type="color" 
                     data-value="${color.name}">
                  <i class="color-circle ${isOut ? 'slashed' : ''}" style="background:${color.value}"></i>
                  <span class="item-text">${color.name}${isOut ? ' – Stokta Yok' : ''}</span>
                </div>
              `;
            }).join('')}
          </div>
        ` : ''}
      </div>
    `;
  }

  function customSizeSelect(bundleId, itemIndex, currentSize) {
    const isOpen = state.openDropdown
      && state.openDropdown.bundleId === bundleId
      && state.openDropdown.itemIndex === itemIndex
      && state.openDropdown.type === 'size';

    return `
      <div class="custom-dropdown-wrap ${isOpen ? 'open' : ''}">
        <button class="custom-dropdown-trigger size-trigger" data-action="toggle-dropdown" data-bundle="${bundleId}" data-index="${itemIndex}" data-type="size" type="button">
          <span class="trigger-label">${currentSize}</span>
          <i class="trigger-arrow">▾</i>
        </button>
        ${isOpen ? `
          <div class="custom-dropdown-menu size-menu">
            ${product.sizes.map(size => {
              const isSelected = size === currentSize;
              return `
                <div class="custom-dropdown-item ${isSelected ? 'selected' : ''}" 
                     data-action="select-dropdown-option" 
                     data-bundle="${bundleId}" 
                     data-index="${itemIndex}" 
                     data-type="size" 
                     data-value="${size}">
                  <span class="item-text">${size}</span>
                </div>
              `;
            }).join('')}
          </div>
        ` : ''}
      </div>
    `;
  }

  function bundleOptions() {
    return `
      <div class="bundle-list">
        ${product.bundles.map(bundle => {
          const isActive = bundle.id === state.selectedBundle;
          const items = state.bundleItems[bundle.id] || [];
          return `
            <div class="bundle-card ${isActive ? "active" : ""}" data-action="bundle" data-bundle="${bundle.id}">
              ${bundle.badge ? `<div class="bundle-badge">${bundle.badge}</div>` : ""}
              <div class="bundle-main-row">
                <div class="radio-dot ${isActive ? "checked" : ""}"></div>
                <div class="bundle-info">
                  <b class="bundle-label">${bundle.label}</b>
                  <small class="bundle-note">${bundle.note}</small>
                </div>
                <div class="bundle-price-box">
                  <strong class="bundle-price">${money(bundle.price)}</strong>
                  <del class="bundle-compare">${money(bundle.compareAt)}</del>
                </div>
              </div>
              ${isActive && items.length ? `
                <div class="bundle-items-container">
                  <div class="bundle-items-header">Renk, Beden</div>
                  ${items.map((item, idx) => `
                    <div class="bundle-item-row ${bundle.quantity === 1 ? "single-item-row" : ""}">
                      ${bundle.quantity > 1 ? `<span class="item-tag">#${idx + 1}</span>` : ""}
                      ${customColorSelect(bundle.id, idx, item.color)}
                      ${customSizeSelect(bundle.id, idx, item.size)}
                    </div>
                  `).join("")}
                </div>
              ` : ""}
              ${bundle.perks && bundle.perks.length > 0 ? `
                <div class="bundle-perks-container">
                  ${bundle.perks.map(perk => `<div class="bundle-perk-item">${perk}</div>`).join("")}
                </div>
              ` : ""}
            </div>
          `;
        }).join("")}
      </div>
    `;
  }

  function variantOptions(forceSingle = false) {
    if (!forceSingle && state.selectedBundle !== "single") return "";
    const activeColor = forceSingle ? state.homeColor : state.selectedColor;
    const activeSize = forceSingle ? state.homeSize : state.selectedSize;
    return `
      <div class="variants">
        <fieldset><legend>${text("colorLabel", "Renk")}</legend><div class="option-row">${product.colors.map(color => `<button class="option color-option ${color.name === activeColor ? "active" : ""}" data-action="color" data-value="${color.name}"><i style="--swatch:${color.value}"></i>${color.name}</button>`).join("")}</div></fieldset>
        <fieldset><legend>${text("sizeLabel", "Beden")}</legend><div class="option-row">${product.sizes.map(size => `<button class="option ${size === activeSize ? "active" : ""}" data-action="size" data-value="${size}">${size}</button>`).join("")}</div></fieldset>
      </div>
    `;
  }

  function accordionList(items, group) {
    return `<div class="accordion-list ${group}">${items.map(item => {
      const normalizedTitle = String(item.title || "").toLocaleLowerCase("tr-TR").trim();
      const isProductSizeChart = group === "details" && normalizedTitle === "beden tablosu";
      const isFaqSizeChart = group === "faq-list" && normalizedTitle === "doğru bedeni nasıl seçerim?";
      const isReturnPolicy = normalizedTitle === "iade ve geri ödeme politikası" || normalizedTitle === "ya beden uymazsa?";
      const forcedLines = isProductSizeChart
        ? ["S, 70 – 80 beden", "M, 80 – 85 beden", "L, 85 – 90 beden", "XL, 90 – 105 beden"]
        : isFaqSizeChart
          ? ["<strong>S:</strong> 70-80 beden aralığı", "<strong>M:</strong> 80-85 beden aralığı", "<strong>L:</strong> 85-90 beden aralığı", "<strong>XL:</strong> 90-105 beden aralığı"]
          : null;
      const lines = forcedLines || (Array.isArray(item.lines) ? item.lines : null);
      const content = lines && lines.length
        ? lines.map(line => `<p>${line}</p>`).join("")
        : `<p>${isReturnPolicy ? "Ürün bedeninize uymazsa 30 gün içinde değişim talep edebilirsiniz." : item.content}</p>`;
      return `<article class="accordion ${isProductSizeChart || item.layout === "size-chart" ? "size-chart-accordion" : ""}"><button data-action="accordion" aria-expanded="false"><span>${item.title}</span><i>+</i></button><div class="accordion-content"><div class="accordion-content-inner">${content}</div></div></article>`;
    }).join("")}</div>`;
  }

  function productPage() {
    return `
      <main id="main" class="product-page">
        <section class="product-top reveal">
          ${productGallery("product")}
          ${productInfo("product")}
        </section>
        <section class="experience-section reveal">
          <div class="experience-grid">
            <div class="experience-media">
              <img src="${mediaAsset("experienceLeft", "chat-left.webp")}" alt="IVK kullanıcı deneyimi" loading="lazy" />
              ${lazyVideo(mediaAsset("ugcVideo1", "ugc-01.mp4"), mediaAsset("ugcPoster1", "ugc-01.webp"))}
              <img src="${mediaAsset("experienceRight", "chat-right.webp")}" alt="IVK kullanıcı deneyimi" loading="lazy" />
              ${lazyVideo(mediaAsset("ugcVideo2", "ugc-02.mp4"), mediaAsset("ugcPoster2", "ugc-02.webp"))}
              ${lazyVideo(mediaAsset("ugcVideo3", "ugc-03.mp4"), mediaAsset("ugcPoster3", "ugc-03.webp"))}
              <img src="${mediaAsset("experienceLeft", "chat-left.webp")}" alt="IVK kullanıcı deneyimi" loading="lazy" />
              ${lazyVideo(mediaAsset("ugcVideo1", "ugc-01.mp4"), mediaAsset("ugcPoster1", "ugc-01.webp"))}
              <img src="${mediaAsset("experienceRight", "chat-right.webp")}" alt="IVK kullanıcı deneyimi" loading="lazy" />
              ${lazyVideo(mediaAsset("ugcVideo2", "ugc-02.mp4"), mediaAsset("ugcPoster2", "ugc-02.webp"))}
              ${lazyVideo(mediaAsset("ugcVideo3", "ugc-03.mp4"), mediaAsset("ugcPoster3", "ugc-03.webp"))}
            </div>
            <div class="experience-copy"><h2>${text("experienceTitle", "IVK’u Kullananların<br />Deneyimlerine Göz Atın")}</h2><p>${text("experienceBody", "Gerçek kullanıcılarımızdan gerçek yorumlar")}</p><a class="button compact-button" href="#reviews">${text("experienceCta", "HEMEN SATIN AL")}</a></div>
          </div>
          <div class="carousel-dots"><i></i><i></i><i class="active"></i><i></i><i></i></div>
        </section>
        <section class="story-section reveal">
          <div class="story-copy"><h2>${text("storyTitle", "Duruşunuzdaki<br />Değişimi Görün.")}</h2><p>${text("storyBody", "Sırtınızı destekleyen yapısıyla gün boyu daha rahat ve dengeli hissetmenize yardımcı olur.")}</p></div>
          ${lazyVideo(mediaAsset("storyVideo", "story.mp4"), mediaAsset("storyPoster", "story-video-poster.webp"), 'controls aria-label="IVK ürün videosu"')}
        </section>
        <section class="comparison-section reveal">
          <h2><strong>${text("comparisonTitle", "Duruşunuzdaki farkı ilk anda hissedin.")}</strong></h2>
          <p>${text("comparisonBody", "Omuzlarınızı, doğal duruşunuzu destekleyen özel çapraz hat ve güçlendirilmiş tasarımıyla kendine güven.")}</p>
          <div class="before-after" style="--pos:50%">
            <img src="${mediaAsset("comparisonBefore", "before.webp")}" alt="Önce" loading="lazy" />
            <div class="after-layer"><img src="${mediaAsset("comparisonAfter", "after.webp")}" alt="Sonra" loading="lazy" /></div>
            <span class="compare-handle">↔</span>
            <input type="range" min="0" max="100" value="50" data-action="compare" aria-label="Önce ve sonra karşılaştırması" />
          </div>
        </section>
        <section class="benefits-section reveal"><h2>${text("benefitsTitle", "Neden IVK?")}</h2><div class="benefit-grid">${DATA.benefits.map(item => `<article><i>${item.icon}</i><h3>${item.title}</h3><p>${item.text}</p></article>`).join("")}</div></section>
        <section class="ugc-section reveal"><div class="ugc-grid"><article>${lazyVideo(mediaAsset("ugcVideo1", "ugc-01.mp4"), mediaAsset("ugcPoster1", "ugc-01.webp"), 'controls aria-label="Müşteri videosu 1"')}</article><article>${lazyVideo(mediaAsset("ugcVideo2", "ugc-02.mp4"), mediaAsset("ugcPoster2", "ugc-02.webp"), 'controls aria-label="Müşteri videosu 2"')}</article><article>${lazyVideo(mediaAsset("ugcVideo3", "ugc-03.mp4"), mediaAsset("ugcPoster3", "ugc-03.webp"), 'controls aria-label="Müşteri videosu 3"')}</article></div></section>
        <div class="navy-wave"></div>
        <section class="product-cta reveal"><div><h2>${text("ctaTitle", "IVK’unla Bugün Tanış!")}</h2><p>${text("ctaBody", "IVK'un sunduğu konfor ve stili kaçırmayın. Günlük konforunuzu yükseltmek için aşağıya tıklayın!")}</p><button class="button" data-action="scroll-buy">${text("ctaButton", "Şimdi Alışveriş Yapın ve Konforunuzu Yükseltin")}</button></div><img src="${mediaAsset("ctaImage", "product-07.webp")}" alt="IVK bej sütyen" loading="eager" decoding="async" style="background-image:url('${mediaAsset("ctaImage", "product-07.webp")}')" /></section>
        <section class="product-testimonials reveal"><h2>${text("productTestimonialsTitle", "Kadınların IVK Hakkındaki Görüşleri")}</h2><div>${DATA.testimonials.map((item, index) => `<article class="${index === state.testimonialIndex ? "active" : ""}"><strong>${[text("testimonialTitle1", "Şimdiye kadarki en iyi sütyen!"), text("testimonialTitle2", "Her Durum İçin Mükemmel"), text("testimonialTitle3", "Oyun Değiştirici")][index]}</strong><p>${item.quote}</p></article>`).join("")}</div><div class="carousel-dots">${DATA.testimonials.map((_, i) => `<i class="${i === state.testimonialIndex ? "active" : ""}" data-action="product-testimonial-dot" data-index="${i}"></i>`).join("")}</div></section>
        <section class="faq-section reveal"><h2>${text("faqTitle", "Sıkça Sorulan Sorular")}</h2><div class="faq-grid"><img src="${mediaAsset("faqImage", "product-10.webp")}" alt="IVK siyah sütyen" loading="eager" decoding="async" style="background-image:url('${mediaAsset("faqImage", "product-10.webp")}')" />${accordionList(DATA.faq, "faq-list")}</div></section>
        <section class="review-heading reveal"><div>${stars(5)} <span>${product.rating} | ${product.ratingCount} ${text("ratingSuffix", "değerlendirme")}</span></div><h1>${text("reviewHeroTitle", "Gerçek Kullanıcı<br class=\"mobile-only\" /> Deneyimleri")}</h1></section>
        ${reviewsSection("product")}
      </main>
    `;
  }

  function reviewsSection(context) {
    const userReviews = JSON.parse(localStorage.getItem("ivk-user-reviews") || localStorage.getItem("gercekform-user-reviews") || "[]");
    const allItems = [...userReviews, ...DATA.reviews];
    const isFiltered = document.querySelector('[data-action="review-filter"]')?.getAttribute("aria-pressed") === "true";
    const filteredItems = isFiltered ? allItems.filter(r => Number(r.rating) === 5) : allItems;

    const pageSize = 5;
    const totalPages = Math.ceil(filteredItems.length / pageSize) || 1;
    const page = Math.min(state.reviewPage, totalPages);
    const visibleItems = filteredItems.slice((page - 1) * pageSize, page * pageSize);

    return `
      <section id="reviews" class="reviews-section ${context === "home" ? "home-reviews" : ""} reveal">
        <div class="reviews-head"><div><h3>${text("reviewsTitle", "Müşteri Değerlendirmeleri")}</h3><p>${text("reviewsSummary", `<b>5.0</b> ${allItems.length} değerlendirme`)}</p></div><button class="button review-button" data-action="open-review">${text("reviewButton", "Değerlendirme yazın")}</button><button class="square-button ${isFiltered ? "active" : ""}" data-action="review-filter" aria-label="5 yıldızlı yorumları filtrele" aria-pressed="${isFiltered}">▽</button><button class="square-button" data-action="review-sort" aria-label="Yorumları sırala">↕</button></div>
        <div class="review-media">${[1,2,3,4,5].map(i => `<img src="${mediaAsset("reviewImage" + i, `review-0${i}.webp`)}" alt="Müşteri değerlendirmesi ${i}" loading="eager" decoding="async" />`).join("")}</div>
        <div class="review-list">${visibleItems.map((review, index) => `<article class="review-item" data-rating="${Number(review.rating)}"><div class="review-stars">${stars(Number(review.rating))}</div><div class="reviewer"><i>${escapeHTML(review.name).charAt(0).toLowerCase()}</i><span><b>${escapeHTML(review.name)}</b><em>${index < userReviews.length ? "Yeni" : "Doğrulanmış"}</em><small>${escapeHTML(review.date)}</small></span></div>${review.title ? `<h4>${escapeHTML(review.title)}</h4>` : ""}<p>${escapeHTML(review.text)}</p></article>`).join("")}</div>
        <div class="pagination"><button data-action="review-page" data-page="prev" aria-label="Önceki yorum sayfası">‹</button>${Array.from({ length: Math.min(totalPages, 5) }, (_, i) => `<button data-action="review-page" data-page="${i + 1}" class="${i + 1 === page ? "active" : ""}">${i + 1}</button>`).join("")}${totalPages > 5 ? `<span>…</span><button data-action="review-page" data-page="${totalPages}">${totalPages}</button>` : ""}<button data-action="review-page" data-page="next" aria-label="Sonraki yorum sayfası">›</button></div>
      </section>
    `;
  }

  function footer() {
    return `
      <footer id="footer" class="site-footer">
        <div class="footer-wave"><i></i><i></i><i></i><i></i></div>
        <div class="footer-grid">
          <section><h2>${text("footerNewsletterTitle", "E-posta listemize abone olun,<br />tamamen ücretsiz!")}</h2><p>${text("footerNewsletterBody", "Tüm yıl boyunca teklifler ve indirimler sunuyoruz; aşağıdan katılarak bunları kaçırmadığınızdan emin olun.")}</p><form class="newsletter"><input type="email" name="email" placeholder="${text("newsletterPlaceholder", "E-posta")}" required /><button class="button" type="submit">${text("footerNewsletterButton", "IVK Ailesine Katılın!")}</button></form></section>
          <section><h2>${text("footerLinksTitle", "Hızlı bağlantılar")}</h2><nav>${footerLinks.map(item => `<a href="${ivkHref(item.href)}"${item.policy ? ` data-action="policy" data-policy="${item.policy}"` : ""}>${item.label}</a>`).join("")}</nav></section>
          <section><h2>${text("footerQuestionsTitle", "Sorular - Soru ?")}</h2><p>${text("footerQuestionsBody", `Sorularınız için lütfen <a href="mailto:${DATA.brand.email}">${DATA.brand.email}</a> adresinden veya buradan bize ulaşın. Destek ekibimiz her gün sabah 9'dan akşam 6'ya kadar hizmetinizdedir.`)}</p></section>
        </div>
        <div class="footer-bottom"><div class="payment-icons"><span>Pay</span><span>●●</span><span>VISA</span><span>Pay</span></div><small>${DATA.brand.copyright}</small></div>
      </footer>
    `;
  }

  function cartDrawer() {
    return `<div class="cart-overlay" data-action="close-cart"></div><aside class="cart-drawer" aria-label="Sepet" aria-hidden="true"><div class="cart-head"><span class="brand-text" style="font-size:22px;letter-spacing:8px">IVK</span><button class="icon-button" data-action="close-cart">${icons.close}</button></div><div id="cart-drawer-body">${cartBody()}</div></aside>`;
  }

  function cartBody() {
    if (!state.cart.length) {
      return `<div class="empty-cart"><h2>${text("emptyCartTitle", "Sepetiniz boş")}</h2><p>${text("emptyCartBody", "Favori ürünlerinizi sepetinize ekleyin.")}</p></div>`;
    }
    const subtotal = state.cart.reduce((sum, item) => sum + item.price * item.qty, 0);
    const hasDiscount = Boolean(state.discountCode.trim());
    const discountAmount = hasDiscount ? subtotal * 0.10 : 0;
    const finalTotal = subtotal - discountAmount;

    const reserveMins = String(Math.floor(state.reserveTimerSeconds / 60)).padStart(2, "0");
    const reserveSecs = String(state.reserveTimerSeconds % 60).padStart(2, "0");

    return `
      <div class="filled-cart">
        <h2>${text("cartTitle", "Sepet")} <small>• ${cartCount()} ${text("cartItemSuffix", "ürün")}</small></h2>
        <p class="reserve">${text("reservePrefix", "Sepetiniz")} <b data-reserve>${reserveMins}:${reserveSecs}</b> ${text("reserveSuffix", "dakika rezerve edildi.")}</p>
        <div class="cart-lines">
          ${state.cart.map((item, index) => `<article><img src="${item.image}" alt="${item.name}" /><div><h3>${item.name}</h3><p>${item.variantSummary || `${item.color} / ${item.size}`} · ${item.bundleLabel}</p><strong>${money(item.price)}</strong><div class="quantity"><button data-action="cart-minus" data-index="${index}">${icons.minus}</button><span>${item.qty}</span><button data-action="cart-plus" data-index="${index}">${icons.plus}</button><button class="remove" data-action="cart-remove" data-index="${index}">${text("removeText", "Kaldır")}</button></div></div></article>`).join("")}
        </div>
        <form class="discount" aria-label="İndirim kodu" novalidate>
          <input name="discount" type="text" inputmode="text" enterkeyhint="done" autocapitalize="characters" autocomplete="off" placeholder="${text("couponPlaceholder", "İndirim kodu")}" value="${escapeHTML(state.discountCode)}" />
          <button type="submit" data-action="discount">${text("couponApply", "EKLE")}</button>
        </form>
        <div class="subtotal">
          <span>${text("subtotalText", "Ara toplam")}</span>
          <strong>${money(subtotal)}</strong>
        </div>
        ${hasDiscount ? `<div class="subtotal discount-line"><span>İndirim (%10 - ${escapeHTML(state.discountCode)})</span><strong style="color:#27ae60">-${money(discountAmount)}</strong></div><div class="subtotal total-line"><span>Genel Toplam</span><strong>${money(finalTotal)}</strong></div>` : ""}
        <button class="button checkout-button" data-action="checkout">${text("checkoutText", "ÖDEMEYE GEÇ")}</button>
        <button class="continue" data-action="close-cart">${text("continueShopping", "Alışverişe devam et")}</button>
      </div>
    `;
  }

  function checkoutModalHTML() {
    return `<button class="icon-button checkout-close" data-action="close-checkout">${icons.close}</button><span class="brand-text" style="font-size:26px;letter-spacing:10px;margin:12px 0">IVK</span><h2>${text("checkoutTitle", "Siparişini Tamamla")}</h2><p>${text("checkoutBody", "Kapıda ödeme için teslimat bilgilerini gir.")}</p><form id="checkout-form"><div class="field-row"><label>${text("firstNameLabel", "Ad")}<input name="name" required /></label><label>${text("lastNameLabel", "Soyad")}<input name="surname" required /></label></div><label>${text("phoneLabel", "Telefon")}<input name="phone" type="tel" required placeholder="05__ ___ __ __" /></label><label>${text("addressLabel", "Adres")}<textarea name="address" required rows="3"></textarea></label><div class="field-row"><label>${text("cityLabel", "İl")}<input name="city" required /></label><label>${text("districtLabel", "İlçe")}<input name="district" required /></label></div><button class="button cod-button" type="submit">${text("codOrderButton", "Kapıda Ödeme Siparişi Oluştur")}</button></form>`;
  }

  function checkoutModal() {
    return `<div class="checkout-overlay" data-action="close-checkout"></div><section class="checkout-modal" role="dialog" aria-modal="true" aria-label="Siparişi tamamla">${checkoutModalHTML()}</section>`;
  }

  function utilityModals() {
    return `
      <div class="utility-overlay" data-action="close-utility"></div>
      <section class="utility-modal search-modal" role="dialog" aria-modal="true" aria-label="Ürün ara">
        <button class="icon-button utility-close" data-action="close-utility">${icons.close}</button>
        <h2>${text("searchTitle", "Ara")}</h2><label class="search-field">${icons.search}<input type="search" data-search-input placeholder="${text("searchPlaceholder", "Ürün ara...")}" autocomplete="off" /></label>
        <a class="search-result" href="/products/ivk"><img src="${product.images[0]}" alt="${product.name}" /><span><b>${product.name}</b><small>${money(product.price)}</small></span></a>
      </section>
      <section class="utility-modal review-modal" role="dialog" aria-modal="true" aria-label="Değerlendirme yaz">
        <button class="icon-button utility-close" data-action="close-utility">${icons.close}</button>
        <h2>${text("reviewModalTitle", "Değerlendirme yazın")}</h2>
        <form id="review-form"><label>${text("reviewerNameLabel", "Adınız")}<input name="name" required /></label><label>${text("reviewRatingLabel", "Puan")}<select name="rating"><option value="5">★★★★★</option><option value="4">★★★★☆</option><option value="3">★★★☆☆</option></select></label><label>${text("reviewCommentLabel", "Yorumunuz")}<textarea name="text" rows="4" required></textarea></label><button class="button" type="submit">${text("saveReviewButton", "Yorumu Kaydet")}</button></form>
      </section>
      <section class="utility-modal policy-modal" role="dialog" aria-modal="true" aria-label="IVK politikası">
        <button class="icon-button utility-close" data-action="close-utility">${icons.close}</button>
        <div data-policy-content></div>
      </section>`;
  }

  function editorPanel() {
    if (!new URLSearchParams(location.search).has("edit")) return "";
    return `<aside class="editor-panel"><b>IVK Düzenleyici</b><button data-action="editor-toggle">Metinleri Düzenle</button><button data-action="editor-save">Kaydet</button><button data-action="editor-reset">Sıfırla</button></aside>`;
  }

  function infoPage(info) {
    return `<main id="main" class="info-page"><article><span>IVK</span><h1>${info.title}</h1>${info.paragraphs.map(paragraph => `<p>${paragraph.replace("info@ivksatis.com", '<a href="mailto:info@ivksatis.com">info@ivksatis.com</a>')}</p>`).join("")}</article></main>`;
  }

  function render() {
    const isProduct = currentPath().startsWith("/products/ivk") || currentPath().startsWith("/products/gercekform");
    const info = infoPages[currentPath()];
    document.title = isProduct ? `${product.name} – IVK` : info ? `${info.title} – IVK` : "IVK";
    document.getElementById("app").innerHTML = `${header()}${mobileMenu()}${isProduct ? productPage() : info ? infoPage(info) : homePage()}${footer()}${cartDrawer()}${checkoutModal()}${utilityModals()}${editorPanel()}`;
    updateCountdown();
    observeReveals();
    setupEditor();
    setupCodPulse();
    setupLazyVideos();
  }

  function setupLazyVideos() {
    const videos = [...document.querySelectorAll("video[data-src]")];
    if (!videos.length) return;
    const load = video => {
      if (!video.src) {
        video.src = video.dataset.src;
        video.load();
      }
      const play = video.play();
      if (play?.catch) play.catch(() => {});
    };
    if (!("IntersectionObserver" in window)) {
      videos.forEach(load);
      return;
    }
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) load(entry.target);
        else if (!entry.target.controls) entry.target.pause();
      });
    }, { rootMargin: "350px 0px", threshold: 0.01 });
    videos.forEach(video => observer.observe(video));
  }

  function setupCodPulse() {
    const button = document.querySelector(".product-page .cod-button");
    if (!button) return;
    const pulse = () => {
      button.classList.remove("pulse");
      void button.offsetWidth;
      button.classList.add("pulse");
      setTimeout(() => button.classList.remove("pulse"), 830);
    };
    setTimeout(pulse, 1200);
    setInterval(pulse, 5200);
  }

  function cartCount() {
    return state.cart.reduce((sum, item) => sum + item.qty, 0);
  }

  function saveCart(options = {}) {
    localStorage.setItem("ivk-cart", JSON.stringify(state.cart));
    localStorage.setItem("gercekform-cart", JSON.stringify(state.cart));
    const body = document.getElementById("cart-drawer-body");
    const previousScrollTop = body?.scrollTop || 0;
    if (body) body.innerHTML = cartBody();
    document.querySelectorAll(".cart-count").forEach(el => {
      el.textContent = cartCount();
      el.classList.toggle("visible", cartCount() > 0);
    });
    if (body && (options.restoreScroll || options.revealDiscount)) {
      requestAnimationFrame(() => {
        if (options.revealDiscount) {
          const result = body.querySelector(".discount-line") || body.querySelector(".discount");
          result?.scrollIntoView({ block: "nearest" });
        } else {
          body.scrollTop = previousScrollTop;
        }
      });
    }
  }

  function applyCartDiscount(input) {
    const code = input?.value.trim() || "IVK10";
    state.discountCode = code;
    localStorage.setItem("ivk-discount-code", code);
    saveCart({ revealDiscount: true });
    showToast(`İndirim kodu uygulandı (%10): ${code}`);
  }

  function openCart() {
    state.cartOpen = true;
    document.body.classList.add("cart-open");
    document.querySelector(".cart-drawer")?.setAttribute("aria-hidden", "false");
  }

  function closeCart() {
    state.cartOpen = false;
    document.body.classList.remove("cart-open");
    document.querySelector(".cart-drawer")?.setAttribute("aria-hidden", "true");
  }

  const normalizeOption = value => String(value || "").toLocaleLowerCase("tr-TR").replace(/[%()]/g, "").replace(/\s+/g, " ").trim();

  function resolveShopifyVariant(bundle, color, size) {
    if (!SHOPIFY) return null;
    const bundleWords = {
      single: ["tekli", "single"],
      double: ["ikili", "double"],
      triple: ["üçlü", "uclu", "triple"]
    }[bundle.id] || [bundle.id];
    const c = normalizeOption(color);
    const s = normalizeOption(size);
    const mappedVariant = window.GF_VARIANT_MAP?.[`${bundle.id}|${c}|${s}`];
    if (mappedVariant?.id && mappedVariant.available !== false) return mappedVariant;
    return (SHOPIFY.variants || []).find(variant => {
      const options = (variant.options || []).map(normalizeOption);
      return options.includes(c) && options.includes(s) && bundleWords.some(word => options.some(option => option.includes(normalizeOption(word))));
    }) || null;
  }

  async function postShopify(url, body) {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body)
    });
    if (!response.ok) throw new Error(await response.text());
    return response.json();
  }

  async function hydrateShopifyCart() {
    if (!SHOPIFY) return;
    try {
      const response = await fetch(SHOPIFY.routes.cart, { headers: { Accept: "application/json" } });
      if (!response.ok) return;
      const cart = await response.json();
      state.cart = cart.items.flatMap(item => {
        const properties = item.properties || {};
        const isRecommendation = item.handle === "sekillendirici-sort-tayt" || item.product_title === DATA.recommendation.name;
        const bundleId = properties._gf_bundle || "single";
        const bundle = product.bundles.find(candidate => candidate.id === bundleId) || product.bundles[0];
        const baseItem = {
          key: properties._gf_key || item.key,
          shopifyKey: item.key,
          variantId: item.variant_id,
          id: item.product_id,
          name: item.product_title || item.title,
          color: properties.Renk || properties.Color || state.selectedColor,
          size: properties.Beden || properties.Size || state.selectedSize,
          bundle: bundleId,
          bundleLabel: properties.Paket || (isRecommendation ? "Tekli" : bundle.label),
          variantSummary: properties._gf_variant_summary || "",
          units: bundle.quantity,
          price: Number(item.final_price || item.price) / 100,
          qty: item.quantity,
          image: item.image || (isRecommendation ? DATA.recommendation.image : product.images[0])
        };

        if (isRecommendation || bundle.quantity <= 1) return [baseItem];

        const summaryParts = String(properties._gf_variant_summary || "").split(/,\s*/);
        const packageTotalCents = Math.round(bundle.price * 100);
        const packageBaseCents = Math.floor(packageTotalCents / bundle.quantity);
        const packageRemainderCents = packageTotalCents - packageBaseCents * bundle.quantity;
        const packageItems = Array.from({ length: bundle.quantity }, (_, index) => {
          const propertyValue = properties[`${index + 1}. Ürün`]
            || properties[`${index + 1}. Urun`]
            || summaryParts[index]?.replace(/^#\d+\s*/, "")
            || "";
          const [color = state.selectedColor, size = state.selectedSize] = String(propertyValue).split(/\s*\/\s*/);
          return {
            ...baseItem,
            key: `${baseItem.key}-${index + 1}`,
            color,
            size,
            variantSummary: `${color} / ${size}`,
            units: 1,
            price: (packageBaseCents + (index < packageRemainderCents ? 1 : 0)) / 100,
            bundleItemIndex: index + 1
          };
        });
        return packageItems;
      });
      saveCart();
    } catch (error) {
      console.warn("Shopify sepeti okunamadı", error);
    }
  }

  async function syncShopifyQuantity(item, quantity) {
    if (!SHOPIFY || !item?.shopifyKey) return;
    try {
      await postShopify(SHOPIFY.routes.cartChange, { id: item.shopifyKey, quantity: Math.max(0, quantity) });
      await hydrateShopifyCart();
    } catch (error) {
      console.warn("Shopify sepet miktarı güncellenemedi", error);
      showToast("Sepet güncellenemedi, tekrar deneyin");
    }
  }

  async function addRecommendationToShopify() {
    if (!SHOPIFY?.recommendationVariantId) return;
    try {
      await postShopify(SHOPIFY.routes.cartAdd, {
        items: [{
          id: Number(SHOPIFY.recommendationVariantId),
          quantity: 1,
          properties: { _gf_key: "recommendation-shorts", Renk: "Bej", Beden: "S", Paket: "Tekli" }
        }]
      });
      await hydrateShopifyCart();
    } catch (error) {
      console.error("Öneri ürünü sepete eklenemedi", error);
      showToast("Öneri ürünü sepete eklenemedi");
    }
  }

  async function addProduct(buyNow = false) {
    const bundle = product.bundles.find(item => item.id === state.selectedBundle) || product.bundles[0];
    const items = state.bundleItems[bundle.id] || [{ color: state.selectedColor, size: state.selectedSize }];

    let variantSummary = "";
    if (bundle.quantity > 1) {
      variantSummary = items.map((it, idx) => `#${idx + 1} ${it.color} / ${it.size}`).join(", ");
    } else {
      variantSummary = `${items[0]?.color || state.selectedColor} / ${items[0]?.size || state.selectedSize}`;
    }

    const mainColor = items[0]?.color || state.selectedColor;
    const mainSize = items[0]?.size || state.selectedSize;
    const colorOrder = product.colors.map(item => item.name);
    const canonicalItems = items.slice().sort((left, right) => {
      const colorDifference = colorOrder.indexOf(left.color) - colorOrder.indexOf(right.color);
      return colorDifference || product.sizes.indexOf(left.size) - product.sizes.indexOf(right.size);
    });
    const variantColor = bundle.quantity > 1 ? canonicalItems.map(item => item.color).join(" + ") : mainColor;
    const variantSize = bundle.quantity > 1 ? canonicalItems.map(item => item.size).join(" + ") : mainSize;
    const key = `${product.id}-${bundle.id}-${variantSummary}`;
    const checkoutProperties = {
      _gf_key: key,
      _gf_bundle: bundle.id,
      _gf_variant_summary: variantSummary,
      Paket: bundle.label
    };
    if (bundle.quantity > 1) {
      items.forEach((item, index) => {
        checkoutProperties[`${index + 1}. Ürün`] = `${item.color} / ${item.size}`;
      });
    } else {
      checkoutProperties.Renk = mainColor;
      checkoutProperties.Beden = mainSize;
    }

    if (SHOPIFY) {
      const variant = resolveShopifyVariant(bundle, variantColor, variantSize);
      if (!variant) {
        showToast("Shopify ürün varyantı bulunamadı");
        return;
      }
      try {
        await postShopify(SHOPIFY.routes.cartAdd, {
          items: [{
            id: Number(variant.id),
            quantity: 1,
            properties: checkoutProperties
          }]
        });
      } catch (error) {
        console.error("Shopify sepete ekleme hatası", error);
        showToast("Ürün sepete eklenemedi, tekrar deneyin");
        return;
      }
    }

    const current = state.cart.find(item => item.key === key);
    if (current) {
      current.qty += 1;
    } else {
      state.cart.push({
        key,
        id: product.id,
        name: product.name,
        color: mainColor,
        size: mainSize,
        bundle: bundle.id,
        bundleLabel: bundle.label,
        variantSummary,
        units: bundle.quantity,
        price: bundle.price,
        qty: 1,
        image: product.images[state.selectedImage]
      });
    }
    saveCart();
    showToast("Ürün sepete eklendi");
    openCart();
    if (SHOPIFY) await hydrateShopifyCart();
    if (buyNow) setTimeout(openCheckout, 250);
  }

  function setGallery
(index) {
    state.selectedImage = (index + product.images.length) % product.images.length;
    const main = document.querySelector(".product-gallery .gallery-main");
    if (main) {
      main.classList.add("changing");
      setTimeout(() => { main.src = product.images[state.selectedImage]; main.classList.remove("changing"); }, 120);
    }
    document.querySelectorAll(".thumbnail").forEach((button, i) => button.classList.toggle("active", i === state.selectedImage));
    const activeThumbnail = document.querySelector(".thumbnail.active");
    const thumbnailList = activeThumbnail?.closest(".thumbnail-list");
    if (activeThumbnail && thumbnailList) {
      const targetLeft = activeThumbnail.offsetLeft - (thumbnailList.clientWidth - activeThumbnail.clientWidth) / 2;
      thumbnailList.scrollTo({ left: Math.max(0, targetLeft), behavior: "smooth" });
    }
  }

  function chooseOption(action, value, target) {
    const parent = target.closest(".option-row");
    parent?.querySelectorAll(".option").forEach(el => el.classList.remove("active"));
    target.classList.add("active");
    const isHomeOption = Boolean(target.closest(".home-product-info"));
    if (action === "color") {
      if (isHomeOption) {
        state.homeColor = value;
        return;
      }
      state.selectedColor = value;
      if (state.bundleItems[state.selectedBundle]) {
        state.bundleItems[state.selectedBundle].forEach(it => it.color = value);
      }
    }
    if (action === "size") {
      if (isHomeOption) {
        state.homeSize = value;
        return;
      }
      state.selectedSize = value;
      if (state.bundleItems[state.selectedBundle]) {
        state.bundleItems[state.selectedBundle].forEach(it => it.size = value);
      }
    }
  }

  function openCheckout() {
    if (!state.cart.length) addProduct(false);
    if (SHOPIFY) {
      const checkout = SHOPIFY.routes.checkout || "/checkout";
      window.location.href = state.discountCode
        ? `/discount/${encodeURIComponent(state.discountCode)}?redirect=${encodeURIComponent(checkout)}`
        : checkout;
      return;
    }
    closeCart();
    const modal = document.querySelector(".checkout-modal");
    if (modal && !modal.querySelector("#checkout-form")) {
      modal.innerHTML = checkoutModalHTML();
    }
    document.body.classList.add("checkout-open");
    setTimeout(() => document.querySelector("#checkout-form input")?.focus(), 200);
  }

  function closeCheckout() {
    document.body.classList.remove("checkout-open");
  }

  function showToast(message) {
    const root = document.getElementById("toast-root");
    if (!root) return;
    const toast = document.createElement("div");
    toast.className = "toast";
    toast.textContent = message;
    root.appendChild(toast);
    requestAnimationFrame(() => toast.classList.add("show"));
    setTimeout(() => { toast.classList.remove("show"); setTimeout(() => toast.remove(), 250); }, 2400);
  }

  function updateCountdown() {
    const now = new Date();
    const end = new Date(now);
    end.setHours(24, 0, 0, 0);
    const diff = Math.max(0, end - now);
    const values = {
      hours: String(Math.floor(diff / 3600000)).padStart(2, "0"),
      minutes: String(Math.floor(diff / 60000) % 60).padStart(2, "0"),
      seconds: String(Math.floor(diff / 1000) % 60).padStart(2, "0")
    };
    Object.entries(values).forEach(([key, value]) => document.querySelectorAll(`[data-time="${key}"]`).forEach(el => {
      if (el.textContent !== value) {
        el.textContent = value;
        el.classList.remove("changing");
        void el.offsetWidth;
        el.classList.add("changing");
        setTimeout(() => el.classList.remove("changing"), 300);
      }
    }));
    document.querySelectorAll("[data-flash-time]").forEach(el => el.textContent = `${values.hours}:${values.minutes}:${values.seconds}`);

    if (state.reserveTimerSeconds > 0) {
      state.reserveTimerSeconds -= 1;
    } else {
      state.reserveTimerSeconds = 600;
    }
    const rMins = String(Math.floor(state.reserveTimerSeconds / 60)).padStart(2, "0");
    const rSecs = String(state.reserveTimerSeconds % 60).padStart(2, "0");
    document.querySelectorAll("[data-reserve]").forEach(el => el.textContent = `${rMins}:${rSecs}`);
  }

  function observeReveals() {
    if (!("IntersectionObserver" in window)) return document.querySelectorAll(".reveal").forEach(el => el.classList.add("visible"));
    const observer = new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add("visible"); observer.unobserve(entry.target); } }), { rootMargin: "0px 0px -40px", threshold: 0.06 });
    document.querySelectorAll(".reveal").forEach(el => observer.observe(el));
    setTimeout(() => document.querySelectorAll(".reveal").forEach(el => el.classList.add("visible")), 1200);
  }

  function setupEditor() {
    if (!new URLSearchParams(location.search).has("edit")) return;
    const key = `ivk-edits-${currentPath()}`;
    const saved = JSON.parse(localStorage.getItem(key) || localStorage.getItem(`gercekform-edits-${currentPath()}`) || "{}");
    const editable = document.querySelectorAll("main h1,main h2,main h3,main p,main li,footer h2,footer p,footer a");
    editable.forEach((el, index) => {
      el.dataset.editId = String(index);
      if (saved[index] != null) el.innerHTML = saved[index];
    });
  }

  document.addEventListener("click", event => {
    const target = event.target.closest("[data-action]");
    
    // Close dropdown on outside click
    if (state.openDropdown && (!target || !['toggle-dropdown', 'select-dropdown-option'].includes(target.dataset.action))) {
      state.openDropdown = null;
      render();
    }

    if (!target) return;
    const action = target.dataset.action;

    if (["menu", "close-menu", "cart", "close-cart", "gallery-prev", "gallery-next", "gallery-select", "color", "size", "bundle", "add-cart", "buy-now", "accordion", "cart-minus", "cart-plus", "cart-remove", "discount", "checkout", "close-checkout", "scroll-buy", "testimonial-prev", "testimonial-next", "product-testimonial-dot", "search", "open-review", "policy", "close-utility", "review-filter", "review-sort", "review-page", "editor-toggle", "editor-save", "editor-reset", "toggle-dropdown", "select-dropdown-option"].includes(action)) event.preventDefault();

    if (action === "toggle-dropdown") {
      const bundleId = target.dataset.bundle;
      const itemIndex = Number(target.dataset.index);
      const type = target.dataset.type;
      
      if (state.openDropdown
          && state.openDropdown.bundleId === bundleId
          && state.openDropdown.itemIndex === itemIndex
          && state.openDropdown.type === type) {
        state.openDropdown = null;
      } else {
        state.openDropdown = { bundleId, itemIndex, type };
      }
      render();
    }

    if (action === "select-dropdown-option") {
      const bundleId = target.dataset.bundle;
      const itemIndex = Number(target.dataset.index);
      const type = target.dataset.type;
      const value = target.dataset.value;
      
      const col = product.colors.find(c => c.name === value);
      if (type === 'color' && col && col.inStock === false) {
        showToast(`${value} rengi stokta yoktur`);
        return;
      }
      
      if (state.bundleItems[bundleId] && state.bundleItems[bundleId][itemIndex]) {
        state.bundleItems[bundleId][itemIndex][type] = value;
      }
      state.openDropdown = null;
      render();
    }

    if (action === "menu") { document.body.classList.add("menu-open"); document.querySelector(".mobile-menu")?.setAttribute("aria-hidden", "false"); }
    if (action === "close-menu") { document.body.classList.remove("menu-open"); document.querySelector(".mobile-menu")?.setAttribute("aria-hidden", "true"); }
    if (action === "cart") openCart();
    if (action === "close-cart") closeCart();
    if (action === "gallery-prev") setGallery(state.selectedImage - 1);
    if (action === "gallery-next") setGallery(state.selectedImage + 1);
    if (action === "gallery-select") setGallery(Number(target.dataset.index));
    if (action === "color" || action === "size") chooseOption(action, target.dataset.value, target);
    if (action === "bundle") {
      state.selectedBundle = target.dataset.bundle;
      state.openDropdown = null;
      render();
    }
    if (action === "add-cart") {
      if (target.closest(".home-product-info")) {
        state.selectedBundle = "single";
        state.selectedColor = state.homeColor;
        state.selectedSize = state.homeSize;
        state.bundleItems.single = [{ color: state.homeColor, size: state.homeSize }];
      }
      addProduct(false);
    }
    if (action === "buy-now") {
      if (target.closest(".home-product-info")) {
        state.selectedBundle = "single";
        state.selectedColor = state.homeColor;
        state.selectedSize = state.homeSize;
        state.bundleItems.single = [{ color: state.homeColor, size: state.homeSize }];
      }
      addProduct(true);
    }
    if (action === "accordion") {
      const article = target.closest(".accordion");
      const expanded = article.classList.toggle("open");
      target.setAttribute("aria-expanded", String(expanded));
      target.querySelector("i").textContent = expanded ? "×" : "+";
    }
    if (action === "cart-minus" || action === "cart-plus") {
      const item = state.cart[Number(target.dataset.index)];
      const quantity = item ? item.qty + (action === "cart-plus" ? 1 : -1) : 0;
      if (SHOPIFY && item?.shopifyKey && typeof syncShopifyQuantity === "function") syncShopifyQuantity(item, quantity);
      else {
        if (item) item.qty = quantity;
        state.cart = state.cart.filter(cartItem => cartItem.qty > 0);
        saveCart();
      }
    }
    if (action === "cart-remove") {
      const item = state.cart[Number(target.dataset.index)];
      if (SHOPIFY && item?.shopifyKey && typeof syncShopifyQuantity === "function") syncShopifyQuantity(item, 0);
      else { state.cart.splice(Number(target.dataset.index), 1); saveCart(); }
    }
    if (action === "discount") {
      const input = target.closest(".discount")?.querySelector("input");
      applyCartDiscount(input);
    }
    if (action === "checkout") openCheckout();
    if (action === "close-checkout") closeCheckout();
    if (action === "scroll-buy") { document.querySelector(".product-top")?.scrollIntoView({ behavior: "smooth" }); }
    if (action === "search") {
      document.body.classList.add("search-open");
      const input = document.querySelector("[data-search-input]");
      if (input) { input.value = ""; }
      document.querySelector(".search-result")?.removeAttribute("hidden");
      setTimeout(() => input?.focus(), 150);
    }
    if (action === "open-review") document.body.classList.add("review-open");
    if (action === "policy") {
      const info = infoPages[`/pages/${target.dataset.policy}`];
      const content = document.querySelector("[data-policy-content]");
      if (info && content) {
        content.innerHTML = `<span>IVK</span><h2>${info.title}</h2>${info.paragraphs.map(paragraph => `<p>${paragraph.replace("info@ivksatis.com", '<a href="mailto:info@ivksatis.com">info@ivksatis.com</a>')}</p>`).join("")}`;
        document.body.classList.add("policy-open");
      }
    }
    if (action === "close-utility") document.body.classList.remove("search-open", "review-open", "policy-open");
    if (action === "review-filter") {
      const current = target.getAttribute("aria-pressed") === "true";
      target.setAttribute("aria-pressed", String(!current));
      state.reviewPage = 1;
      render();
    }
    if (action === "review-sort") {
      const list = document.querySelector(".review-list");
      if (list) [...list.children].reverse().forEach(item => list.appendChild(item));
      target.classList.toggle("active");
    }
    if (action === "review-page") {
      const requested = target.dataset.page;
      if (requested === "prev") state.reviewPage = Math.max(1, state.reviewPage - 1);
      else if (requested === "next") state.reviewPage = state.reviewPage + 1;
      else state.reviewPage = Number(requested) || 1;
      render();
      document.querySelector("#reviews")?.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    if (action === "product-testimonial-dot") {
      state.testimonialIndex = Number(target.dataset.index) || 0;
      document.querySelectorAll(".product-testimonials article").forEach((el, i) => el.classList.toggle("active", i === state.testimonialIndex));
      document.querySelectorAll(".product-testimonials .carousel-dots i").forEach((el, i) => el.classList.toggle("active", i === state.testimonialIndex));
    }
    if (action === "editor-toggle") {
      document.body.classList.toggle("editing");
      document.querySelectorAll("[data-edit-id]").forEach(el => el.contentEditable = document.body.classList.contains("editing") ? "true" : "false");
    }
    if (action === "editor-save") {
      const edits = {}; document.querySelectorAll("[data-edit-id]").forEach(el => edits[el.dataset.editId] = el.innerHTML);
      localStorage.setItem(`ivk-edits-${currentPath()}`, JSON.stringify(edits)); showToast("Düzenlemeler kaydedildi");
    }
    if (action === "editor-reset") { localStorage.removeItem(`ivk-edits-${currentPath()}`); localStorage.removeItem(`gercekform-edits-${currentPath()}`); location.reload(); }
    if (action === "testimonial-prev" || action === "testimonial-next") {
      const track = document.querySelector(".testimonial-track");
      track?.scrollBy({ left: (action === "testimonial-next" ? 1 : -1) * track.clientWidth, behavior: "smooth" });
    }
  });

  document.addEventListener("input", event => {
    if (event.target.matches('[data-action="compare"]')) event.target.closest(".before-after").style.setProperty("--pos", `${event.target.value}%`);
    if (event.target.matches("[data-search-input]")) {
      const q = event.target.value.trim().toLocaleLowerCase("tr-TR");
      const visible = !q || product.name.toLocaleLowerCase("tr-TR").includes(q) || "sütyen duruş ivk".includes(q);
      document.querySelector(".search-result")?.toggleAttribute("hidden", !visible);
    }
  });

  document.addEventListener("submit", async event => {
    if (event.target.matches(".discount")) {
      event.preventDefault();
      applyCartDiscount(event.target.querySelector("input"));
      return;
    }
    if (event.target.matches(".newsletter")) {
      event.preventDefault();
      const email = new FormData(event.target).get("email");
      const subscribers = JSON.parse(localStorage.getItem("ivk-subscribers") || localStorage.getItem("gercekform-subscribers") || "[]");
      if (email && !subscribers.includes(email)) subscribers.push(email);
      localStorage.setItem("ivk-subscribers", JSON.stringify(subscribers));
      if (SHOPIFY && email) {
        const body = new URLSearchParams({ form_type: "customer", utf8: "✓", "contact[email]": email, "contact[tags]": "newsletter" });
        fetch("/contact", { method: "POST", headers: { "Content-Type": "application/x-www-form-urlencoded" }, body }).catch(() => {});
      }
      showToast("IVK ailesine hoş geldiniz!");
      event.target.reset();
    }
    if (event.target.id === "checkout-form") {
      event.preventDefault();
      const order = { id: `IVK-${Date.now().toString().slice(-7)}`, createdAt: new Date().toISOString(), customer: Object.fromEntries(new FormData(event.target)), items: state.cart };
      const orders = JSON.parse(localStorage.getItem("ivk-orders") || localStorage.getItem("gercekform-orders") || "[]");
      orders.push(order);
      localStorage.setItem("ivk-orders", JSON.stringify(orders));
      state.cart = [];
      saveCart();
      const modal = document.querySelector(".checkout-modal");
      modal.innerHTML = `<div class="order-success"><span>✓</span><h2>Siparişiniz Alındı!</h2><p>Sipariş numaranız <b>${order.id}</b>. Teslimat öncesi telefonla bilgilendirileceksiniz.</p><button class="button" data-action="close-checkout">Alışverişe dön</button></div>`;
    }
    if (event.target.id === "review-form") {
      event.preventDefault();
      const data = Object.fromEntries(new FormData(event.target));
      const reviews = JSON.parse(localStorage.getItem("ivk-user-reviews") || localStorage.getItem("gercekform-user-reviews") || "[]");
      reviews.unshift({ ...data, date: new Date().toLocaleDateString("tr-TR") });
      localStorage.setItem("ivk-user-reviews", JSON.stringify(reviews));
      document.body.classList.remove("review-open");
      event.target.reset();
      render();
      showToast("Değerlendirmeniz kaydedildi");
    }
  });

  document.addEventListener("keydown", event => {
    if (event.key === "Escape") {
      if (state.openDropdown) {
        state.openDropdown = null;
        render();
      } else {
        closeCart(); closeCheckout(); document.body.classList.remove("menu-open", "search-open", "review-open", "policy-open");
      }
    }
  });

  window.addEventListener("scroll", () => document.body.classList.toggle("scrolled", window.scrollY > 150), { passive: true });
  setInterval(updateCountdown, 1000);
  setInterval(() => {
    const track = document.querySelector(".testimonial-track");
    if (!track || innerWidth > 700) return;
    const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
    track.scrollTo({ left: atEnd ? 0 : track.scrollLeft + track.clientWidth, behavior: "smooth" });
  }, 4200);

  render();
  if (SHOPIFY && typeof hydrateShopifyCart === "function") hydrateShopifyCart();
})();
